import { __assign } from "tslib";
import { createHttpTestKit } from '../../../http/test-kit';
import { createMyStatisticsInsightsApi } from '../';
import { createFakePostResponder } from '../../../test-utils';
export var createMyStatisticsInsightsApiTestkit = function (parent) {
    if (parent === void 0) { parent = 'localhost'; }
    var fakeHttp = createHttpTestKit();
    var api = createMyStatisticsInsightsApi(parent, fakeHttp);
    var base = parent + "/analytics/me";
    var handler = {
        whenGetOverview: createFakePostResponder(fakeHttp, base + "/overview"),
        whenGetNumberOfRepliesCounts: createFakePostResponder(fakeHttp, base + "/numberOfReplies/counts"),
        whenGetNumberOfRepliesHistogram: createFakePostResponder(fakeHttp, base + "/numberOfReplies/histogram"),
        whenGetSolvedTicketsCounts: createFakePostResponder(fakeHttp, base + "/solvedTickets/counts"),
        whenGetSolvedTicketsHistogram: createFakePostResponder(fakeHttp, base + "/solvedTickets/histogram"),
        whenGetCallVolumeCounts: createFakePostResponder(fakeHttp, base + "/callVolume/counts"),
        whenGetCallVolumeHistogram: createFakePostResponder(fakeHttp, base + "/callVolume/histogram"),
        whenGetHandleTimeCounts: createFakePostResponder(fakeHttp, base + "/handleTime/counts"),
        whenGetHandleTimeHistogram: createFakePostResponder(fakeHttp, base + "/handleTime/histogram"),
        whenGetAssistedCallsCounts: createFakePostResponder(fakeHttp, base + "/assistedCalls/counts"),
        whenGetAssistedCallsHistogram: createFakePostResponder(fakeHttp, base + "/assistedCalls/histogram"),
        whenGetNewPublishedArticlesCounts: createFakePostResponder(fakeHttp, base + "/newPublishedArticles/counts"),
        whenGetNewPublishedArticlesHistogram: createFakePostResponder(fakeHttp, base + "/newPublishedArticles/histogram"),
        whenGetArticleUpdatesCounts: createFakePostResponder(fakeHttp, base + "/articleUpdates/counts"),
        whenGetArticleUpdatesHistogram: createFakePostResponder(fakeHttp, base + "/articleUpdates/histogram"),
        whenGetServedChatsHistogram: createFakePostResponder(fakeHttp, base + "/servedChats/histogram"),
    };
    return __assign(__assign({}, api), handler);
};
//# sourceMappingURL=testkit.js.map